import React from "react";

const SvgTag = props => (
  <svg width="19" viewBox="0 0 19 19" {...props}>
    <path
      d="M15.13 6.72C14.97 6.55 8.54.12 8.7.29A.984.984 0 0 0 8 0H1.99A1.978 1.978 0 0 0 .01 1.98v6.01a.984.984 0 0 0 .29.7c3.88 3.88 1.09 1.08 9.71 9.71a1.986 1.986 0 0 0 2.8 0l5.6-5.6a1.986 1.986 0 0 0 0-2.8zm-4.42 9.58L2.14 7.72a.469.469 0 0 1-.15-.35v-4.4a.986.986 0 0 1 .99-.99h4.41a.518.518 0 0 1 .35.14l8.57 8.58a.984.984 0 0 1 0 1.4l-4.2 4.2a.984.984 0 0 1-1.4 0zM3.78 4.76a.992.992 0 0 1 .99-.99.986.986 0 0 1 .99.99.986.986 0 0 1-.99.99.992.992 0 0 1-.99-.99z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgTag;
